export const checkInView = (dataId) => {
    return location.href.indexOf(dataId) !== -1;
};
